import { createAction, props } from '@ngrx/store';
import { IUser } from '../../models/user';


export const GetGraphDetailsApiAction = createAction('[GraphDetails] Get GraphDetails', props<{ email: string }>());
export const SuccessGetGraphDetailsApiAction = createAction('[GraphDetails] Success Get GraphDetails', props<{ graphDetails: IUser }>());
export const ErrorGetGraphDetailsApiAction = createAction('[GraphDetails] Error Get GraphDetails', props<Error>());
